import { render, staticRenderFns } from "./vipCardTypeMgt.vue?vue&type=template&id=76681310&scoped=true&"
import script from "./vipCardTypeMgt.vue?vue&type=script&lang=js&"
export * from "./vipCardTypeMgt.vue?vue&type=script&lang=js&"
import style0 from "./vipCardTypeMgt.vue?vue&type=style&index=0&id=76681310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76681310",
  null
  
)

component.options.__file = "vipCardTypeMgt.vue"
export default component.exports